import { FileSizePipe } from '@file-upload/pipes/file-size.pipe';
import { MbToBPipe } from '@file-upload/pipes/mb-to-b.pipe';
import { RenditionsUrlOrDefaultPipe } from '@file-upload/pipes/renditions-url-or-default.pipe';
import { SasPipe } from '@file-upload/pipes/sas.pipe';
import { AttachmentsZipDownloadService } from '@file-upload/services/attachments-zip-download.service';
import { AttachmentsZipService } from '@file-upload/services/attachments-zip.service';
import { AttachmentsService } from '@file-upload/services/attachments.service';
import { FileSaverService } from '@file-upload/services/file-saver.service';
import { FileValidationService } from '@file-upload/services/file-validation.service';
import { FilesStateService } from '@file-upload/services/files-state.service';
import { FilesService } from '@file-upload/services/files.service';

export const FILE_UPLOAD_PROVIDERS = [
  AttachmentsService,
  AttachmentsZipDownloadService,
  AttachmentsZipService,
  FileSaverService,
  FilesService,
  FilesStateService,
  FileValidationService,

  FileSizePipe,
  MbToBPipe,
  RenditionsUrlOrDefaultPipe,
  SasPipe
];
